import { Schema as S } from "effect";

/**
 * Vendor-reported difference between stored patient and card data.
 * @since 1.1.11
 * @example
 * const value = FieldDiff.make({ path: "firstname", changed: true });
 */
export const FieldDiff = S.Struct({
  label: S.optional(S.String),
  path: S.optional(S.String),
  patientValue: S.optional(S.NullOr(S.Unknown)),
  cardValue: S.optional(S.NullOr(S.Unknown)),
  type: S.optional(S.String),
  changed: S.optional(S.Boolean),
  parentPath: S.optional(S.String),
  parentPathLabel: S.optional(S.String),
  index: S.optional(S.Number),
  isEnum: S.optional(S.Boolean),
});
/**
 * Decoded value of {@link FieldDiff}.
 * @since 1.1.11
 * @example
 * const value: FieldDiff = { path: "firstname", changed: true };
 */
export type FieldDiff = S.Schema.Type<typeof FieldDiff>;
